var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('attachment-list',{attrs:{"delete-permission":'change_auction',"change-permission":'change_auction',"object-uuid":_vm.sale.uuid,"plural-object-name":"auctions","object-name":"auction"}})}
var staticRenderFns = []

export { render, staticRenderFns }